<div class="portals-page">
    <div class="portals-hero-box">
        <div class="portals-hero-heading">
            <h2 class="portals-title">Your Companies</h2>
            <p class="portals-subtitle">Choose a company to open its dashboard.</p>
        </div>

        <nz-list nzBordered nzItemLayout="horizontal" class="portals-list">
            <nz-list-item *ngFor="let company of companies" (click)="onCompanyClick(company)"
                [class.active-item]="selectedCompanyId === company.id" class="selectable-company-item">

                <nz-list-item-meta [nzAvatar]="businessAvatar" [nzTitle]="company.company?.name"
                    nzDescription="Click to switch to this company dashboard">
                </nz-list-item-meta>

                <ul nz-list-item-actions>
                    <nz-list-item-action>
                        <button nz-button nzType="primary" [nzGhost]="selectedCompanyId !== company.id">
                            <span>Select</span>
                            <span nz-icon nzType="right"></span>
                        </button>
                    </nz-list-item-action>
                </ul>

                <div class="web-portal-indicator" *ngIf="selectedCompanyId === company.id">
                    <div class="arcane-ring-small"></div>
                </div>
            </nz-list-item>
        </nz-list>
    </div>
</div>